import React from 'react'
import moment from 'moment'
import { useMedia } from 'sb-hooks'

import MonthItem from './Month/Month'


const QueueItems = (props) => {
  const {
    items, viewOnly, emptyQueueFirstCellPlus, square, isQueueEmptyPlusCellEnabled,
    onTrackingNumberClick, onClick, onRemove, onFocus, onBlur, onKeyDown,
    ariaDescribedby,
  } = props
  const { isMobile } = useMedia()

  const isOneProductPlan = !items.some(({ products }) => products.length > 1)

  return items.map((item, index) => {
    const { year, month } = item

    const dateKey   = `${month}${year}`
    const date      = moment(`${month < 10 ? '0' : ''}${dateKey}`, 'MMYYYY')
    const itemData  = { ...item, date }

    // Added id for Onboarding Tour
    const isOnboardingTourItem              = isMobile && !isOneProductPlan ? !index : index === 2
    const isQueueEmptyFirstCellPlusEnabled  = emptyQueueFirstCellPlus && index === 0

    return (
      <MonthItem
        key={dateKey}
        data={itemData}
        viewOnly={viewOnly}
        square={square}
        ariaDescribedby={ariaDescribedby}
        isOnboardingTourItem={isOnboardingTourItem}
        isQueueEmptyPlusCellEnabled={isQueueEmptyPlusCellEnabled}
        isQueueEmptyFirstCellPlusEnabled={isQueueEmptyFirstCellPlusEnabled}
        onBlur={onBlur}
        onFocus={onFocus}
        onClick={onClick}
        onRemove={onRemove}
        onKeyDown={onKeyDown}
        onTrackingNumberClick={onTrackingNumberClick}
      />
    )
  })
}


export default QueueItems
